module.exports = __webpack_public_path__ + "@/assets/img/koku-beyaz.32f89c18.jpeg";